export default __webpack_public_path__ + "static/SR France - Safety Data Sheet - Caramel Color (Liquid)-2b5a919702d2b5bb592a462558c84e4b.pdf";